import Reserves from '../components/Exportation/Reserves'
import Users from '../components/Exportation/Users'
import Requests from '../components/Exportation/Requests'
import Divergences from '../components/Exportation/Divergences'

let routes = {
    path: '/exportation',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/exportation/reserves',
            name: 'Exportação - Reservas',
            component: Reserves
        },
        {
            path: '/exportation/users',
            name: 'Exportação - Usuários',
            component: Users
        },
        {
            path: '/exportation/requests_history',
            name: 'Exportação - Histórico de Consultas',
            component: Requests
        },
        {
            path: '/exportation/divergences',
            name: 'Exportação - Não conformidades',
            component: Divergences
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/exportation.js